<script>
    import {getDeepProp} from "../../../common/common";

    export default {
        name: "UrlQueryRule",

        inject: {
            urlQueryHandler: {
                default() {
                    return null;
                }
            }
        },

        props: {
            value: {
                type: String | Number | Object,
            },

            valueKey: String,

            default: {
                type: String | Number | Object,
                default: null
            },

            name: {
                type: String,
                required: true
            },

            isArray: {
                type: Boolean,
                default: false
            },

            options: Array
        },

        render() {
            return null;
        },

        data() {
            return {
                innerValue: null,
            }
        },

        created() {
            if (!this.urlQueryHandler) {
                console.warn("[UrlQueryRule] Can't work without a handler");
            } else {
                this.urlQueryHandler.registerRule(this, this.innerValue);
            }
        },

        computed: {
            handlerQueryMap() {
                return this.urlQueryHandler ? this.urlQueryHandler.queryMap() : null;
            }
        },

        watch: {
            value: {
                immediate: true,
                handler(to) {
                    if (this.isArray && Array.isArray(to) && to.length > 0) {
                        this.innerValue = JSON.stringify(to);
                    } else if (! this.isArray && to !== null && to !== undefined) {
                        this.innerValue = this.valueKey ? getDeepProp(to, this.valueKey) : to.toString();
                    } else {
                        this.innerValue = null;
                    }
                }
            },

            innerValue: {
                handler(to) {
                    if (this.urlQueryHandler) {
                        this.urlQueryHandler.updateRuleValue(this, to);
                    }
                }
            },

            handlerQueryMap: {
                immediate: true,
                deep: true,
                handler(to, from) {
                    if (to && !from) {
                        if ((to[this.name] || to[this.name] === 0) && this.innerValue !== to[this.name]) {
                            try {
                                const value = this.isArray ? JSON.parse(to[this.name]) : to[this.name];
                                if (this.isArray && ! Array.isArray(value)) {
                                    return;
                                }

                                if (this.options) {
                                    const option = this.options.find(o => {
                                        const optionValue = this.valueKey ? getDeepProp(o, this.valueKey) : o.toString();
                                        return value === optionValue;
                                    });

                                    this.$emit('input', option);
                                } else {
                                    this.$emit('input', value);
                                }
                            } catch (e) {
                                // Failed to parse value
                            }
                        } else if (!this.innerValue) {
                            this.$emit('input', this.default);
                        }
                    }
                }
            }
        },
    }
</script>